export const LIST_SUMMARY_RECOMMENDATION_REQUEST = 'LIST_SUMMARY_RECOMMENDATION_REQUEST'
export const LIST_SUMMARY_RECOMMENDATION_SUCCESS = 'LIST_SUMMARY_RECOMMENDATION_SUCCESS'
export const LIST_SUMMARY_RECOMMENDATION_FAILURE = 'LIST_SUMMARY_RECOMMENDATION_FAILURE'
export const LIST_SUMMARY_RECOMMENDATION_RESET = 'LIST_SUMMARY_RECOMMENDATION_RESET'

export const LIST_SUMMARY_RECOMMENDATION_SUMARY_REQUEST = 'LIST_SUMMARY_RECOMMENDATION_SUMARY_REQUEST'
export const LIST_SUMMARY_RECOMMENDATION_SUMARY_SUCCESS = 'LIST_SUMMARY_RECOMMENDATION_SUMARY_SUCCESS'
export const LIST_SUMMARY_RECOMMENDATION_SUMARY_FAILURE = 'LIST_SUMMARY_RECOMMENDATION_SUMARY_FAILURE'
export const LIST_SUMMARY_RECOMMENDATION_SUMARY_RESET = 'LIST_SUMMARY_RECOMMENDATION_SUMARY_RESET'

export const CREATE_SUMMARY_RECOMMENDATION_REQUEST = 'CREATE_SUMMARY_RECOMMENDATION_REQUEST'
export const CREATE_SUMMARY_RECOMMENDATION_SUCCESS = 'CREATE_SUMMARY_RECOMMENDATION_SUCCESS'
export const CREATE_SUMMARY_RECOMMENDATION_FAILURE = 'CREATE_SUMMARY_RECOMMENDATION_FAILURE'

export const DETAIL_SUMMARY_RECOMMENDATION_REQUEST = 'DETAIL_SUMMARY_RECOMMENDATION_REQUEST'
export const DETAIL_SUMMARY_RECOMMENDATION_SUCCESS = 'DETAIL_SUMMARY_RECOMMENDATION_SUCCESS'
export const DETAIL_SUMMARY_RECOMMENDATION_FAILURE = 'DETAIL_SUMMARY_RECOMMENDATION_FAILURE'

export const UPDATE_SUMMARY_RECOMMENDATION_REQUEST = 'UPDATE_SUMMARY_RECOMMENDATION_REQUEST'
export const UPDATE_SUMMARY_RECOMMENDATION_SUCCESS = 'UPDATE_SUMMARY_RECOMMENDATION_SUCCESS'
export const UPDATE_SUMMARY_RECOMMENDATION_FAILURE = 'UPDATE_SUMMARY_RECOMMENDATION_FAILURE'

export const DELETE_SUMMARY_RECOMMENDATION_REQUEST = 'DELETE_SUMMARY_RECOMMENDATION_REQUEST'
export const DELETE_SUMMARY_RECOMMENDATION_SUCCESS = 'DELETE_SUMMARY_RECOMMENDATION_SUCCESS'
export const DELETE_SUMMARY_RECOMMENDATION_FAILURE = 'DELETE_SUMMARY_RECOMMENDATION_FAILURE'

